import { AbstractComponent } from "appworks/components/abstract-component";
import { DualPosition } from "appworks/graphics/pixi/dual-position";

export class TrailDisplayComponent extends AbstractComponent {
    public landDelay: number = 0;

    public getPosition(): DualPosition {
        return new DualPosition();
    }

    public upgrade(upgradeLevel?: number): void { }

    public sparkLanded(): void { }

    protected setLevel(level: number): void { }
}
